export const doesHaveCoverage = interview => {
    const coverage = interview.coverage;

    if (coverage)
        return (
            (interview.coverage.provideManualCoverage && interview.coverage.coverageConfirmed) ||
            interview.coverage.coverageSummary?.personCoverages?.some(x => x.isActive === true) ||
            interview.coverage.isFullyCovered
        );
    else return false;
};

export const doesProvidedCoverageMatchesVerified = coverage => {
    const primaryCoverage = coverage.primaryCoverage;
    const supplementalCoverage = coverage.supplementalCoverage;
    const coverageSummary = coverage.coverageSummary;
    // helper flags
    const hasPrimaryCoverage = !(
        primaryCoverage == undefined ||
        primaryCoverage == null ||
        primaryCoverage.typeOfCoverage == null ||
        primaryCoverage.typeOfCoverage == undefined
    );
    const hasSupplementalCoverage = !(
        supplementalCoverage == undefined ||
        supplementalCoverage == null ||
        supplementalCoverage.typeOfCoverage == null ||
        supplementalCoverage.typeOfCoverage == undefined
    );

    // check for coverage summary if it exists make sure it has data
    const hasCoverageSummary =
        coverageSummary?.personCoverages == undefined ||
        coverageSummary?.personCoverages == null ||
        coverageSummary?.personCoverages?.length === 0 ||
        coverageSummary?.personCoverages.some(x => x.coverageSource.name !== "Interview");

    // nothing was provided and nothing was returned, return positive
    if (!hasPrimaryCoverage && !hasSupplementalCoverage && !hasCoverageSummary) {
        return true;
    }

    // nothing was provided, but coverage was returned
    if (!hasPrimaryCoverage && !hasPrimaryCoverage && hasCoverageSummary) {
        return false;
    }

    // coverage was provided, but nothing was returned
    if (hasPrimaryCoverage && !hasCoverageSummary) {
        return false;
    }

    // till here, coverage was provided and returned
    if (hasPrimaryCoverage && hasCoverageSummary) {
        // company name and type of insurance need to be the same
        if (
            coverageSummary?.personCoverages?.some(
                x => x.companyName == primaryCoverage.companyName && x.coverageSource.name !== "Interview"
            ) ||
            coverageSummary?.personCoverages?.some(
                x =>
                    x.healthInsuranceType.name == primaryCoverage.typeOfCoverage &&
                    x.coverageSource.name !== "Interview"
            )
        ) {
            return true;
        }
    }

    // if primary did not check, test supplemental, if exists
    if (hasSupplementalCoverage && hasCoverageSummary) {
        if (
            coverageSummary?.personCoverages.some(
                x => x.companyName == supplementalCoverage.companyName && x.coverageSource.name !== "Interview"
            ) &&
            coverageSummary?.personCoverages.some(
                x =>
                    x.healthInsuranceType.name == supplementalCoverage.typeOfCoverage &&
                    x.coverageSource.name !== "Interview"
            )
        ) {
            return true;
        }
    }
    // otherwise...
    return false;
};

export const extractCoverageCollected = coverage => {
    let collectedCoverage = null;
    if (coverage && coverage?.coverageSource && coverage.coverageSource?.name === "Interview") {
        if (coverage.coverageSummary?.personCoverages && coverage.coverageSummary.personCoverages.length > 0) {
            collectedCoverage = coverage.coverageSummary.personCoverages.filter(
                x => x.coverageSource.name === "Interview" && x.isPrimaryCoverage == true && x.copay !== null
            )[0];
        }
    } else {
        if (coverage.coverageSummary?.personCoverages && coverage.coverageSummary.personCoverages.length > 0) {
            collectedCoverage = coverage.coverageSummary.personCoverages.filter(
                x => x.coverageSource.name === "Availity" && x.isPrimaryCoverage == true && x.copay !== null
            )[0];
        }
    }

    return collectedCoverage;
};

export const jsonContainErrors = coverageJson => {
    return coverageJson.summary.coverages.some(x => x.statusCode === "19");
};

export const getJsonErrors = coverageJson => {
    return coverageJson.summary.coverages.find(x => x.statusCode === "19");
};

export const formatDisplayDates = dateToFormat => {
    const date = new Date(dateToFormat);
    const formattedDate =
        (date.getMonth() > 8 ? date.getMonth() + 1 : "0" + (date.getMonth() + 1)) +
        "/" +
        (date.getDate() > 9 ? date.getDate() : "0" + date.getDate()) +
        "/" +
        date.getFullYear();
    return formattedDate;
};
